import React, { useCallback, useEffect, useRef, useState } from 'react';

import LoadingPop from 'pages/Loading';
import { MenuRestaurant } from './MenuRestaurant';

import { useHistory } from 'react-router-dom';
import { useCardapioContext } from 'hooks/Cardapio';

import * as T from './interfaces';
import sizes from 'utils/screenSizes';
import scrollToComponent from 'utils/scrollToComponent';

export const Container: React.FC<T.IMenuRestaurant> = ({ containerRef }) => {
  const history = useHistory();

  const {
    category,
    setPositionCategory,
    handleSelectCategory,
    loading,
    selectedStore,
    setStoreSelected,
    findStoreById,
  } = useCardapioContext();

  const [hideBanner, setHideBanner] = useState(false);
  const [hideSearch, setHideSearch] = useState(false);
  const [openModalSecondAccess, setOpenModalSecondAccess] = useState(false);
  const [isPositionCategory, setIsPositionCategory] = useState(false);

  const onPressChooseRestaurant = () => {
    history.push('/menu');
  };

  const onPressAnyCategoryFilter = (positionScrollCategorySelected: number) => {
    containerRef.current.scrollTo({
      top: positionScrollCategorySelected,
      behavior: 'smooth',
    });
  };

  const hideModalSecondAccess = () => {
    setOpenModalSecondAccess(false);
  };

  const handleClickProduct = (idProduct: string) => {
    history.push('/cardapio/produto');

    const url = new URL(window.location.href);
    selectedStore &&
      url.searchParams.set('loja', String(`00${selectedStore.id}`));
    url.searchParams.set('produto', idProduct);
    window.history.pushState({}, '', url);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current.scrollTop === 0) {
        setHideBanner(false);
      } else {
        setHideBanner(true);
      }

      if (window.screen.width < parseInt(sizes.notebook, 10)) {
        if (containerRef.current.scrollTop >= 170) {
          setHideSearch(true);
        } else {
          setHideSearch(false);
        }
      } else if (containerRef.current.scrollTop >= 320) {
        setHideSearch(true);
      } else {
        setHideSearch(false);
      }

      const categoryPositioned = category.filter(
        categoryPosition =>
          containerRef.current.scrollTop + 20 >
          categoryPosition.positionCategoryContainer,
      );

      if (categoryPositioned.length > 0) {
        const lastCategoryPositioned = categoryPositioned.length - 1;
        handleSelectCategory(categoryPositioned[lastCategoryPositioned].id);
      }
    };

    containerRef.current.addEventListener('scroll', handleScroll);
  }, [containerRef.current, category]);

  useEffect(() => {
    const url = new URL(window.location.href);
    const storeId = Number(url.searchParams.get('loja'));
    const modalSecondAccessStorage = localStorage.getItem(
      '@Popeyes.modalSecondAccess',
    );
    const stausModalSecondAccessStorage: boolean = JSON.parse(
      modalSecondAccessStorage,
    );
    if (selectedStore) {
      const url = new URL(window.location.href);
      url.searchParams.set('loja', String(selectedStore.id));
      window.history.pushState({}, '', url);
    } else if (storeId) {
      findStoreById(storeId);
    }

    if (selectedStore && !modalSecondAccessStorage) {
      localStorage.setItem('@Popeyes.modalSecondAccess', JSON.stringify(false));
    } else if (stausModalSecondAccessStorage === false) {
      setOpenModalSecondAccess(true);
      localStorage.setItem('@Popeyes.modalSecondAccess', JSON.stringify(true));
    }
  }, []);

  useEffect(() => {
    if (category.length > 1 && !isPositionCategory) {
      setPositionCategory();
      setIsPositionCategory(true);
    }
  }, [loading]);

  return (
    <>
      {loading && <LoadingPop />}
      <MenuRestaurant
        containerRef={containerRef}
        hideBanner={hideBanner}
        hideSearch={hideSearch}
        onPressChooseRestaurant={onPressChooseRestaurant}
        categories={category}
        onPressAnyCategoryFilter={onPressAnyCategoryFilter}
        storeSelected={selectedStore}
        hideModalSecondAccess={hideModalSecondAccess}
        openModalSecondAccess={openModalSecondAccess}
        handleClickProduct={handleClickProduct}
      />
    </>
  );
};
